// Get modules array from localStorage
function getModules() {
  const data = localStorage.getItem("permissions");
  return data ? JSON.parse(data) : [];
}

// Check a specific permission
// can("Client", "delete") → true / false
export function can(module, permission) {
  const modules = getModules();

  const mod = modules.find((m) => m.name === module);
  if (!mod) return false;

  const perm = mod.permissions?.find((p) => p.name === permission);
  return perm?.allowed === true;
}
